import { render, staticRenderFns } from "./OtherSolutionModal.vue?vue&type=template&id=2e0d834f&scoped=true"
import script from "./OtherSolutionModal.vue?vue&type=script&lang=js"
export * from "./OtherSolutionModal.vue?vue&type=script&lang=js"
import style0 from "./OtherSolutionModal.vue?vue&type=style&index=0&id=2e0d834f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d834f",
  null
  
)

export default component.exports